import { useMemo } from 'react';
import { applyColumnWidths } from './wrapDataGridColumns';
import type { GridColumnWidthModel } from './gridState';
import type { GridColDef, GridValidRowModel } from '@/ui/primitives';

export const useServerTableColumns = <T extends GridValidRowModel>(
  columns: ReadonlyArray<GridColDef<T>>,
  columnWidthModel: GridColumnWidthModel,
): Array<GridColDef<T>> =>
  useMemo(() => applyColumnWidths(columns, columnWidthModel), [columnWidthModel, columns]);
